import { render } from "./Edit.vue?vue&type=template&id=3fdd88e6"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/CourseDepartments/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3fdd88e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fdd88e6', __exports__)) {
    api.reload('3fdd88e6', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=3fdd88e6", () => {
    api.rerender('3fdd88e6', render)
  })

}


export default __exports__